import { action, computed, observable } from 'mobx';
import { observer } from 'mobx-react';
import {
    autoinject,
    bind,
    Contract,
    Enums,
    inject,
    Modal,
    ModalHandle,
    ServicesAlert,
    TasksStore,
    Tooltip,
} from 'Mri.Web.Common';
import { stringify } from 'qs';
import * as React from 'react';
import { LinkContainer } from 'react-router-bootstrap';
import { Button, ButtonGroup } from 'reactstrap';
import { AccountStore } from '../Account/AccountStore';
import { ContractsStore } from '../Contracts/ContractsStore';
import { DisplayFiltersStore } from '../DisplayFilters/DisplayFiltersStore';
import { BsJustify } from '@react-icons/all-files/bs/BsJustify';
import { BsTrash } from '@react-icons/all-files/bs/BsTrash';
import { BsPencilSquare } from '@react-icons/all-files/bs/BsPencilSquare';
import { BsBookmarkPlus } from '@react-icons/all-files/bs/BsBookmarkPlus';
import { ContractModal } from '../Contracts/ContractModal';

export interface IAccountContractProps {
    readonly contract: Contract;
    readonly accountName?: string;
    readonly hideIfNoExpirations?: boolean;
}

@autoinject
@observer
export class AccountContractItem extends React.Component<IAccountContractProps> {
    public render() {
        const { contract } = this.props;

        return (
            this.shouldRenderContract ?
            <tr>
                <td className="fw-bold align-middle">
                    <div className="flex-items-center">
                        <a onClick={this.openContractModal} className="btn btn-link">
                            {contract.serviceCO}
                        </a>
                        <ServicesAlert onClick={this.openContractModal} contract={contract} className="d-inline-block" />
                    </div>
                </td>

                <td className="align-middle">{Enums.toString(Enums.ServiceLevel, contract.serviceLevel)}</td>

                <td className="align-middle">
                    <a onClick={this.openContractModal} className={this.inWarranty ? 'text-success' : 'text-danger'}>
                        {contract.contractStatusMessage()}
                    </a>
                </td>

                <td className="align-middle">{contract.term} Months</td>

                <td className="align-middle">{contract.formatStartDate()}</td>

                <td className="align-middle">{contract.formatEndDate()}</td>
                <td className="align-middle">
                    <ButtonGroup size="sm">
                        {/*{this.accountStore.isInRoles(['MriAdmin']) && (*/}
                        {/*    <Tooltip message="Update" delay={0}>*/}
                        {/*        <Button color="primary" onClick={this.update}>*/}
                        {/*            <BsArrowUpShort style={{ fontSize: 22 }} />*/}
                        {/*        </Button>*/}
                        {/*    </Tooltip>*/}
                        {/*)}*/}

                        {this.accountStore.isInRoles(['MriAdmin']) && (
                            <>
                                <div>
                                    <Tooltip message="Edit Contract" delay={0}>
                                        <Button
                                            color="primary"
                                            onClick={this.openEditContractModal}
                                            style={{ margin: '0px 2px 0px 2px' }}
                                        >
                                            <BsPencilSquare className="" />
                                        </Button>
                                    </Tooltip>
                                </div>
                                <div>
                                    <Tooltip message="Edit Displays" delay={0}>
                                        <LinkContainer exact to={`accounts/${contract.serviceCO}`}>
                                            <Button color="secondary">
                                                <BsBookmarkPlus className="" />
                                            </Button>
                                        </LinkContainer>
                                    </Tooltip>
                                </div>
                            </>
                        )}

                        <div>
                            <Tooltip message="View Displays" delay={0}>
                                <a href={'/displays' + this.search} className="btn btn-secondary" target="_blank">
                                    <BsJustify className="" />
                                </a>
                            </Tooltip>
                        </div>

                        <div>
                            {this.accountStore.isInRoles(['MriAdmin']) && (
                                <Tooltip message="Delete" delay={0}>
                                    <Button color="danger" onClick={this.deleteAsync}>
                                        <BsTrash className="" />
                                    </Button>
                                </Tooltip>
                            )}
                        </div>
                    </ButtonGroup>
                </td>

                {this.renderModals && (
                    <>
                        <ContractModal
                            contract={contract}
                            viewState={this.contractViewState}
                            accountName={this.props.accountName}
                            modalHandle={this.contractModalHandle}
                        />
                        <Modal
                            className="modal-sm"
                            title="Confirm Deletion"
                            modalHandle={this.modalHandle}
                            btnClass="w-50"
                            footerClass="d-flex justify-content-center"
                        >
                            <div className="text-center">{`Delete ${contract.serviceCO}?`}</div>
                        </Modal>
                    </>
                )}
            </tr>
                : 
            <></>
        );
    }

    @bind
    @action
    private async update() {
        const task = this.tasksStore.startSessionTask(`Update Contract ${this.props.contract.serviceCO}`);

        try {
            await this.contractsStore.updateAsync(this.props.contract.serviceCO);
            task.complete();
        } catch (e: any) {
            task.error(e);
        }
    }

    @bind
    @action
    private async deleteAsync() {
        this.renderModals = true;

        if (await this.modalHandle.confirm()) {
            const task = this.tasksStore.startSessionTask(`Delete Contract ${this.props.contract.serviceCO}`);

            try {
                await this.contractsStore.deleteAsync(this.props.contract.serviceCO);
                task.complete();
            } catch (e: any) {
                task.error(e);
            }
        }
    }

    @bind
    @action
    private openEditContractModal() {
        this.contractViewState = 'edit';
        this.renderModals = true;
        this.contractModalHandle.open();
    }

    @bind
    @action
    private openContractModal(event?: React.MouseEvent<HTMLAnchorElement>) {
        event?.preventDefault();
        this.contractViewState = 'readOnly';
        this.renderModals = true;
        this.contractModalHandle.open();
    }

    @computed
    private get inWarranty() {
        return this.props.contract.inWarranty();
    }

    @computed
    private get search() {
        const displayFilter: Mri.DisplayFilters.DisplayFilter = {
            contracts: [this.props.contract],
        };
        const query = stringify({
            displayFilter: JSON.stringify(displayFilter),
        });
        return '?' + query;
    }
    
    @computed
    private get shouldRenderContract(){
        if(this.props.hideIfNoExpirations && !this.props.contract.expiredRecently() && !this.props.contract.expiringWithin90Days()) return false;
        return true;
    }

    @observable
    private renderModals = false;
    @observable
    private contractViewState: 'readOnly' | 'edit' = 'readOnly';
    private modalHandle = new ModalHandle();
    @inject
    private accountStore!: AccountStore;
    @inject
    private contractsStore!: ContractsStore;
    @inject
    private tasksStore!: TasksStore;
    @inject
    private displayFiltersStore!: DisplayFiltersStore;
    private contractModalHandle = new ModalHandle();
}
